interface IApiSettings {
  user: {
    register: string;
    getuserById: string;
    update: string;
    changePassword: string;
  };
  auth: {
    normalLogin: string;
    googleLogin: string;
    me: string
    refreshToken: string;
    verifyEmail: string;
    forgotPassword: string;
    resetPassword: string;
  };
  adminUser: {
    addUsers: string;
    getAllUsers: string;
    updateUser: string;
    deleteUser: string;
  };
  vehicle: {
    getAllVehicles: string;
    addVehicle: string;
    updateVehicle: string;
    deleteVehicle: string;
  };
  vehicleCategory: {
    getCategoryByVehicleType: string;
    getVehiclesByVehicleType?: string;
    getVehiclesForCategory?: string;
  };
  insurance: {
    getAllInsurances: string;
    addInsurance: string;
    updateInsurance: string;
    deleteInsurance: string;
  };
}
// type ApiEndpoints = {
//   [key: string]: string;
// };

// interface IApiSettings {
//   user: ApiEndpoints;
//   auth: ApiEndpoints;
//   vehicle: ApiEndpoints;
//   vehicleCategory: ApiEndpoints;
// }


const apiSettings: IApiSettings = {
  user: {
    register: "/register",
    getuserById: "/user",
    update: "/user/update",
    changePassword: "/auth/change-password",
  },
  auth: {
    normalLogin: "/auth/login",
    googleLogin: "/auth/google/login",
    me: "/auth/me",
    refreshToken: "/auth/refresh-token",
    verifyEmail: "/auth/verify-email",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
  },
  adminUser: {
    addUsers: "/admin/admin/register",
    getAllUsers: "/admin/admin/users",
    updateUser: "/admin/admin/users",
    deleteUser: "/admin/admin/user",
  },
  vehicle: {
    getAllVehicles: "/vehicle/admin/vehicles",
    addVehicle: "/vehicle/admin/vehicles",
    updateVehicle: "/vehicle/admin/vehicles",
    deleteVehicle: "/vehicle/admin/vehicles",
  },

  vehicleCategory: {
    getCategoryByVehicleType: "/vehicle/admin/categories/key-value",
    getVehiclesByVehicleType: "/vehicle/categories",
    getVehiclesForCategory: "/vehicle/categories",
  },
  insurance: {
    getAllInsurances: "/admin/admin/insurances",
    addInsurance: "/admin/admin/insurances",
    updateInsurance: "/admin/admin/insurances",
    deleteInsurance: "/admin/admin/insurances",
  },
};

export { apiSettings };
